import { render, staticRenderFns } from "./PromoCategoryEdit.vue?vue&type=template&id=7b521c14&scoped=true&"
import script from "./PromoCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./PromoCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b521c14",
  null
  
)

export default component.exports